import { FC, ReactNode } from 'react'
import { ErrorMessage as BaseErrorMessage, ErrorMessageProps } from 'formik'

export const ErrorMessage: FC<ErrorMessageProps> = ({ name }) => (
  <BaseErrorMessage
    name={name}
    render={(msg) => <TailwindErrorMessage>{msg}</TailwindErrorMessage>}
  />
)

interface TailwindErrorMessageProps {
  children?: ReactNode
}

export const TailwindErrorMessage: FC<TailwindErrorMessageProps> = ({ children }) => (
  <p className="mt-2 text-sm text-red-700">{children}</p>
)
